module.exports = __webpack_public_path__ + "img/prepare.695969ed.png";